import * as React from "react";
import { ButtonType, Form, HiddenInput, CustomButton, CustomSubmitButton, Modal, ModalBody, ModalFooter, ModalSize, Select, TextInput } from "soprasteria-ui-library";
import { IListItem } from "soprasteria-ui-library/dist/models/IFormInput";
import { EmailSettingApi } from "../../../api/EmailSettingApi";
import { useAuth } from "../../../App";
import { setMessage } from "../../../helpers/MessageHelper";
import { ICreateOrUpdateEmailSetting, IEmailSetting } from "../../../models/IEmailSetting";

interface IEmailSettingModal {
    emailSetting: IEmailSetting;
    onSubmit: (emailSetting: ICreateOrUpdateEmailSetting, onCallEnd?: () => void) => void;
    closeModal: () => any;
}

export const EmailSettingModal: React.FunctionComponent<IEmailSettingModal> = ({ emailSetting, onSubmit, closeModal }) => {
    const auth = useAuth();
    const api = new EmailSettingApi(auth);

    const [emailPeriodicities, setEmailPeriodicities] = React.useState<IListItem[]>();
    const [isLoadingEmailPeriodicities, setIsLoadingEmailPeriodicities] = React.useState<boolean>(false);
    const [isFormPending, setIsFormPending] = React.useState<boolean>(false);

    React.useEffect(() => {
        loadEmailPeriodicities();
        document.getElementById("open-email-setting-modal")?.click();
    }, [emailSetting]);

    const loadEmailPeriodicities = () => {
        setIsLoadingEmailPeriodicities(true);

        api.getEmailPeriodicities((allEmailPeriodicities) => {
            const emailPeriodicitiesListItems = allEmailPeriodicities.map<IListItem>((emailPeriodicity) => { return { text: emailPeriodicity.description, value: emailPeriodicity.emailPeriodicityId.toString() } });
            setEmailPeriodicities(emailPeriodicitiesListItems);
            setIsLoadingEmailPeriodicities(false);
        }, undefined);
    }

    const onFormSubmit = (data: ICreateOrUpdateEmailSetting) => {
        setIsFormPending(true);
        onSubmit(data, () => {
            setIsFormPending(false);           
        });
    }

    return (
        <Modal id="email-setting-modal" modalSize={ModalSize.large} header={emailSetting.emailSettingId ? "Redigera e-postinställning" : "Registrera e-postinställning"}>
            <Form onSubmit={onFormSubmit}>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <HiddenInput name="emailSettingId" value={emailSetting.emailSettingId ? emailSetting.emailSettingId.toString() : "-1"} />
                            <TextInput name="emailAddress"
                                label="E-postadress"
                                defaultValue={emailSetting?.emailAddress}
                                pattern={/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}
                                patternValidationMessage="Ogiltigt format på e-postadress"
                                inlineLabel
                                required />
                            <Select name="emailPeriodicityId"
                                label="Tidsintervall"
                                options={emailPeriodicities ?? []}
                                selectedValue={emailSetting.emailPeriodicity?.emailPeriodicityId?.toString()}
                                placeholder="Välj ett tidsintervall"
                                inlineLabel
                                disabled={isLoadingEmailPeriodicities}
                                required
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="text-right btn-group" role="group">
                        <CustomButton buttonType={ButtonType.general} id="close-email-setting-modal" data-dismiss="modal" onClick={() => closeModal()} buttonText="Avbryt" />
                        <CustomSubmitButton isLoading={isFormPending}>Spara</CustomSubmitButton>
                        <input type="hidden" data-toggle="modal" id="open-email-setting-modal" data-target="#email-setting-modal" />
                    </div>
                </ModalFooter>
            </Form>
        </Modal>
    )
}